import type { Resource } from '@/resources/resource_types'

const ENGLISH = 'english'

const hasSetNumber = (resource: Resource) => Boolean(resource.set_number && resource.set_number > 0)

export const hasNonEnglishLanguage = (resources: Resource[]): boolean =>
  resources.some((resource) => Boolean(resource.language) && resource.language !== ENGLISH)

/** A resource with no language of its own is shown under every selection. */
export const filterResourcesByLanguage = (resources: Resource[], selectedLanguage: string): Resource[] => {
  if (!selectedLanguage) {
    return resources
  }
  return resources.filter((resource) => !resource.language || resource.language === selectedLanguage)
}

export const sortBySetNumber = (resources: Resource[]): Resource[] => {
  const numberedSets = resources
    .filter(hasSetNumber)
    .sort((first, second) => (first.set_number ?? 0) - (second.set_number ?? 0))
  const unnumbered = resources.filter((resource) => !hasSetNumber(resource))
  return [...numberedSets, ...unnumbered]
}

export const resourceLanguages = (resources: Resource[]): string[] =>
  [...new Set(resources.map((resource) => resource.language).filter((language): language is string => Boolean(language)))].sort()
